import React, { useEffect, useState } from 'react';
import { ChevronLeft, ChevronRight, Eye } from 'lucide-react';
import { Button } from './Button';
const samplePages = [{
  url: 'https://cdn.magicpatterns.com/uploads/9PnpBVh2H8xpyVymVyDcbV/FE18F22A-1C4B-475F-9A43-BDF3113CA0E9.webp',
  caption: 'Banco de Ejercicios — 3 niveles de dificultad'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/4o78SuziznNcNXyTzuzYd1/35B00340-7C1E-4439-A51B-E1C56914FA33.webp',
  caption: 'Marco teórico claro y comparaciones visuales'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/n9bKgxSHD817fFw3QciEcU/75A4B452-45BD-4A4E-828C-283785775743.webp',
  caption: 'Configuración paso a paso lista para el aula'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/oVHtoA1XeqRgLBR5BA2AiY/256F0E59-14E0-42C4-882B-4805050ACA4E.webp',
  caption: 'Introducción a Python con razones pedagógicas'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/n15TJ6neoyAsuS3htmJN8y/9CF9295E-FC3B-451B-9971-957D30E33A69.webp',
  caption: 'Sintaxis y ejemplos prácticos contextualizados'
}];
export function SamplePages() {
  const [index, setIndex] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => {
      setIndex(prev => (prev + 1) % samplePages.length);
    }, 3500);
    return () => clearInterval(timer);
  }, []);
  const goToPrev = () => setIndex(prev => (prev - 1 + samplePages.length) % samplePages.length);
  const goToNext = () => setIndex(prev => (prev + 1) % samplePages.length);
  return <section className="py-6 md:py-8 px-4 bg-brand-dark border-y border-white/5" data-id="element-217">
      <div className="max-w-2xl mx-auto" data-id="element-218">
        <div className="text-center mb-5" data-id="element-219">
          <div className="inline-flex items-center gap-1.5 bg-brand-accent/10 text-brand-accent border border-brand-accent/30 rounded-full px-3.5 py-1.5 mb-3" data-id="element-220">
            <Eye className="w-3.5 h-3.5" data-id="element-221" />
            <span className="font-bold text-[10px] md:text-xs uppercase tracking-wider" data-id="element-222">
              Mirá por dentro
            </span>
          </div>
          <h2 className="text-xl md:text-3xl font-extrabold text-white mb-2 leading-tight" data-id="element-223">
            Vista previa:{' '}
            <span className="text-brand-accent" data-id="element-224">algunas hojas del Kit</span>
          </h2>
          <p className="text-sm md:text-base text-gray-400 leading-relaxed" data-id="element-225">
            Cada tomo tiene este nivel de detalle pedagógico — listo para
            imprimir y usar.
          </p>
        </div>

        {/* Carousel */}
        <div className="relative" data-id="element-226">
          <div className="bg-brand-card rounded-2xl border border-white/10 p-3 md:p-4 overflow-hidden" data-id="element-227">
            <div className="relative aspect-[3/4] md:aspect-[4/5] rounded-xl overflow-hidden bg-white/5" data-id="element-228">
              {samplePages.map((page, i) => <img key={i} src={page.url} alt={page.caption} className={`absolute inset-0 w-full h-full object-contain transition-opacity duration-700 ${i === index ? 'opacity-100' : 'opacity-0'}`} data-id="element-229" />)}

              {/* Nav arrows */}
              <button onClick={goToPrev} aria-label="Previous" className="absolute left-2 top-1/2 -translate-y-1/2 bg-brand-dark/80 hover:bg-brand-accent hover:text-brand-dark text-white rounded-full w-9 h-9 flex items-center justify-center border border-white/20 transition-colors backdrop-blur-sm" data-id="element-230">
                <ChevronLeft className="w-5 h-5" data-id="element-231" />
              </button>
              <button onClick={goToNext} aria-label="Next" className="absolute right-2 top-1/2 -translate-y-1/2 bg-brand-dark/80 hover:bg-brand-accent hover:text-brand-dark text-white rounded-full w-9 h-9 flex items-center justify-center border border-white/20 transition-colors backdrop-blur-sm" data-id="element-232">
                <ChevronRight className="w-5 h-5" data-id="element-233" />
              </button>
            </div>

            <p className="text-center text-xs md:text-sm text-gray-300 font-medium mt-3 min-h-[2.5em] px-2" data-id="element-234">
              {samplePages[index].caption}
            </p>

            {/* Dots */}
            <div className="flex justify-center gap-1.5 mt-2" data-id="element-235">
              {samplePages.map((_, i) => <button key={i} onClick={() => setIndex(i)} aria-label={`Go to slide ${i + 1}`} className={`h-1.5 rounded-full transition-all ${i === index ? 'w-6 bg-brand-accent' : 'w-1.5 bg-white/20 hover:bg-white/40'}`} data-id="element-236" />)}
            </div>
          </div>
        </div>

        <div className="w-full max-w-sm mx-auto text-center mt-5" data-id="element-237">
          <Button className="text-sm md:text-base py-3.5" data-id="element-238">
            🚀 → QUIERO ESTE KIT AHORA
          </Button>
        </div>
      </div>
    </section>;
}